import { render, staticRenderFns } from "./EducationalGroupTransferInfo.vue?vue&type=template&id=09525b48&"
import script from "./EducationalGroupTransferInfo.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupTransferInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports